import React, { FC } from 'react';
import { Filter } from '../../models/Filter';
import { PaginatedFilterChip } from './PaginatedFilterChip';
import { useFilter } from '../../contexts/table/FilterContext';
import { Name } from '../../models/Name';

interface Props {
    filters: Filter[];
    toggleFilterModal: (trigger: string) => void;
    disableFilterToggling:boolean
}

const FilterChips: FC<Props> = ({ filters = [], toggleFilterModal,disableFilterToggling=false }) => {
    const filterContext = useFilter();

    const handleItemClick = (item: string, index: number, visibleOptions: Name[], filterKey: string) => {
        const realItem = visibleOptions.find(option => option.value === item);
        if (realItem) {
            filterContext.updateFilters(filterKey, realItem.value, realItem.label, filterKey);
        }
    }

    return <div className="flex flex-wrap w-full select-none">
        {filters.filter((filter) => filter.showFilterChips !== false)
            .map((filter, filterIndex) =>
                <PaginatedFilterChip
                    toggleFilterModal={toggleFilterModal}
                    key={'pagedchip-' + filterIndex}
                    accessor={filter.key}
                    filters={filters}
                    lookupList={filterContext.lookup ?? []}
                    handleItemClick={(item, filterKey, visibleOptions) => handleItemClick(item, filterIndex, visibleOptions, filterKey)}
                    removeFilterWithKey={filterKey => filterContext.closeFilter(filterKey)}
                    disableFilterToggling={disableFilterToggling} />
            )}
    </div>
}

export default FilterChips;


